import type { MessageActionInvocationStatus } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { JiraContextData } from './jira-draft-data-command';

export interface JiraDraftDataForCreateAllCommandProperties extends CommandProperties {}

type SerializableValue = string | number | boolean | null | undefined;

/**
 * Draft work item shape as sent from the backend
 */
export type DraftWorkItemRawShape = {
	invocationId: string;
	projectIdOrKey: string;
	issueTypeId: string;
	summary: string;
	fields: Record<
		string,
		| SerializableValue
		| SerializableValue[]
		| Record<string, SerializableValue>
		| Record<string, SerializableValue[]>
		| Record<string, Record<string, SerializableValue>>
	>;
	childInvocationIds?: string[];
	createdIssueKey?: string;
	status?: MessageActionInvocationStatus;
};

/**
 * Result type for the Jira context command.
 */
export type JiraDraftDataForCreateAllCommandResult = {
	// This type is no longer used in the platform version of the table
	success?: boolean;
	context?: JiraContextData;
	error?: string;
	draftWorkItems: DraftWorkItemRawShape[];
};

/**
 * A command sent by a bridge API client to retrieve Jira-specific context
 * information when operating in a Jira staging area environment.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to provide current Jira context information.
 */
export const JiraDraftDataForCreateAllCommand: CommandConstructor<
	JiraDraftDataForCreateAllCommandProperties,
	JiraDraftDataForCreateAllCommandResult
> = createCommand<
	JiraDraftDataForCreateAllCommandProperties,
	JiraDraftDataForCreateAllCommandResult
>('jira-context-for-create-all-command');
